import Locations from "../locations";
import {qs, sprint, locationOf, defer} from "../utils/core";
import { EVENTS } from "./utils/constants";
import ExEpubCFI from "./epubcfi";

class ExLocation extends Locations{
	constructor(spine, request, pause) {
		super(spine, request, pause);

		//置換ExEpubCFI
		this.epubcfi = new ExEpubCFI();

		//閱讀設定
		this.readSetting = null;

		//前景顯示器
		this._rendition = null;

		//任務型顯示器
		this._taskRendition = {};
		this._taskGenPageListKey = "epubjs-task-generate-page-list";
		this._taskGenTTSListKey = "epubjs-task-generate-tts-list";

		//是否正在搜尋
		this._isSearching = false;

		//是否為正常搜尋結束
		this._isNormalSearchComplete = true;

		//cpct切換章節等待顯示時間
		this._genPageListWaitRenderTime = 0;

		//tts切換頁面等待顯示時間
		this._genTTSListWaitRenderTime = 0;

	}

	//設定主要顯示器
	setMainRendition(rendition){
		this._rendition = rendition;
	}

	//搜尋---------------------------------------------------------------------------------------------------

	//開始搜尋
	 search(searchString) {

		if (typeof searchString === "undefined") {
			return;
		}

		this.q.pause();
		if(this._isSearching){
			this._isNormalSearchComplete = false;
			this.q.clear();
		}

		this._isSearching = true;

		this.spine.each(function(section) {
			if (section.linear) {
				this.q.enqueue(this.searchProcess.bind(this), section, searchString);
			}
		}.bind(this));

		return this.q.run().then(function() {
			if(this._isNormalSearchComplete){
				this.emit(EVENTS.LOCATIONS.SEARCH_COMPLETE);
			}else{
				this.emit(EVENTS.LOCATIONS.STOP_SEARCH);
				this._isNormalSearchComplete = true;
			}
			this._isSearching = false;
		}.bind(this));

	}
	searchProcess(section, searchString) {
		return section.load(this.request)
			.then(function() {
				var completed = new defer();
				var matches = section.findBody(searchString);
				if (this._isSearching && matches.length > 0) {
					this.emit(EVENTS.LOCATIONS.GET_SEARCH_MATCHES, matches);
				}
				completed.resolve();
				return completed.promise;
			}.bind(this));
	}

	//停止搜尋
	stopSearch(){
		if(this._isSearching){
			this._isSearching = false;
			this._isNormalSearchComplete = false;
			this.q.clear();
		}
	}

	//頁面清單-------------------------------------------------------------------------------------------
	//生成頁面清單
	generatePageList() {
		if(this._taskRendition[this._taskGenPageListKey] && (!this._taskRendition[this._taskGenPageListKey].taskData || (this._taskRendition[this._taskGenPageListKey].taskData && !this._taskRendition[this._taskGenPageListKey].taskData["isGetPageProcessGoing"]))){
			
			if(!this._taskRendition[this._taskGenPageListKey].taskData){
				this._taskRendition[this._taskGenPageListKey].taskData = {
					totalSpine: this._rendition.book.scrollBarNodeList.length - 1,
					preSpinePercentage: 100 / this._rendition.book.scrollBarNodeList.length,
					curentSpineIndex: null,
					curentSpineNum: null,
					task:this._taskGenPageListKey,
					pageList: [],
					startTimestamp: Math.floor(Date.now() / 1000)
				};
			}else{
				this._taskRendition[this._taskGenPageListKey].taskData["pageList"] = [];
				this._taskRendition[this._taskGenPageListKey].taskData["curentSpineIndex"] = null;
				this._taskRendition[this._taskGenPageListKey].taskData["curentSpineNum"] = null;
				this._taskRendition[this._taskGenPageListKey].taskData["startTimestamp"] = Math.floor(Date.now() / 1000);
			}
			this._taskRendition[this._taskGenPageListKey].taskData["isGetPageProcessGoing"] = true;

			this._taskRendition[this._taskGenPageListKey].manager.q.clear();
			this._taskRendition[this._taskGenPageListKey].clear();

			//更新容器尺寸
			this._rendition.book.resizeTaskContainer(this._taskGenPageListKey);
			if(this._rendition.settings.layout === "reflowable"){
				//更新layout
				let spread = (this._rendition._layout._spread) ? "auto" : "none";
				this._taskRendition[this._taskGenPageListKey].spread(spread);

				//更新theme
				this._taskRendition[this._taskGenPageListKey].themes.sync(this._rendition.themes);

				//更新目前閱讀設定
				this._taskRendition[this._taskGenPageListKey].taskData["readSetting"] = {
					spread: spread,
					theme: this._rendition.themes._booksBackground,
					font: this._rendition.themes._booksFont,
					fontSize: this._rendition.themes._booksFontSize,
					lineHeight: this._rendition.themes._booksLineHeight,
					writingMode: this._rendition.themes._booksWritingMode,
					width:this._rendition._layout.props.width,
					height:this._rendition._layout.props.height
				};
			}

			this.emit(EVENTS.LOCATIONS.GEN_PAGE_START, this._taskRendition[this._taskGenPageListKey].taskData["pageList"]);

			this._taskRendition[this._taskGenPageListKey].spineDisplay(this._taskRendition[this._taskGenPageListKey].book.scrollBarNodeList[0].spineItemsIndex);
		}
	}
	//加入單章節頁面
	attachSectionPages(locations, containerId){
		let sectionItemData = locations[0].start;
		let sectionIndex = sectionItemData.index;

		if(this._taskRendition[containerId] && this._taskRendition[containerId].taskData["isGetPageProcessGoing"] && (this._taskRendition[containerId].taskData["curentSpineIndex"] === null || (this._taskRendition[containerId].taskData["curentSpineIndex"] !== null && this._taskRendition[containerId].taskData["curentSpineIndex"] !== sectionIndex))){

			//unload section
			let nowSection = this._taskRendition[containerId].book.spine.get(sectionIndex);
			if(nowSection && !nowSection._isNowDisplay){
				nowSection.unload();
			}

			this._taskRendition[containerId].taskData["curentSpineIndex"] = sectionIndex;
			this._taskRendition[containerId].taskData["curentSpineNum"] = (this._taskRendition[containerId].taskData["curentSpineNum"] === null) ? 0 : this._taskRendition[containerId].taskData["curentSpineNum"] + 1;

			let genPageProgressData;
			if(this._taskRendition[containerId].taskData["curentSpineNum"] !== this._taskRendition[containerId].taskData["totalSpine"]){

				this._taskRendition[containerId].taskData["pageList"] = this._taskRendition[containerId].taskData["pageList"].concat(locations);

				genPageProgressData = {
					percentage:Math.round((this._taskRendition[containerId].taskData["curentSpineNum"]+1) * this._taskRendition[containerId].taskData["preSpinePercentage"]),
					addSectionPages: locations
				}
				this.emit(EVENTS.LOCATIONS.GEN_PAGE_PROGRESS, genPageProgressData);

				let nextSpineNum = this._taskRendition[containerId].taskData["curentSpineNum"]+1;

				if(this._taskRendition[containerId].taskData["waitRender"]){
					clearTimeout(this._taskRendition[containerId].taskData["waitRender"]);
				}
				this._taskRendition[containerId].taskData["waitRender"] = setTimeout(() => {
					this._taskRendition[containerId].spineDisplay(this._taskRendition[containerId].book.scrollBarNodeList[nextSpineNum].spineItemsIndex);
				}, this._genPageListWaitRenderTime);

				
			}else{
				this._taskRendition[containerId].taskData["pageList"] = this._taskRendition[containerId].taskData["pageList"].concat(locations);

				genPageProgressData = {
					percentage:100,
					addItem: locations
				}
				this.emit(EVENTS.LOCATIONS.GEN_PAGE_PROGRESS, genPageProgressData);

				this._taskRendition[containerId].taskData["isGetPageProcessGoing"] = false;
				let startTimestamp = this._taskRendition[containerId].taskData["startTimestamp"];
				let endTimestamp = Math.floor(Date.now() / 1000);
				let completeTime = `${parseInt((endTimestamp-startTimestamp)/60)}:${(endTimestamp-startTimestamp)%60}`;

				let genPageEndData = {
					completeTime:completeTime,
					pageList:this._taskRendition[containerId].taskData["pageList"],
					readSetting:this._taskRendition[containerId].taskData["readSetting"]
				};
				this.emit(EVENTS.LOCATIONS.GEN_PAGE_END, genPageEndData);
				this.stopGeneratePageListProcess();
			}
		}
	}
	//開始生成頁面清單
	startGeneratePageListProcess(){
		if(!this._taskRendition[this._taskGenPageListKey]){
			this._rendition.book.createTaskRendition(this._taskGenPageListKey).then((containerId, taskRendition)=>{
				this._taskRendition[containerId] = taskRendition;
				this._taskRendition[containerId].on("allLocated", (locations) => this.attachSectionPages.call(this, locations, containerId));
				this._taskRendition[containerId].on("displayerror", error => {
				    console.log("%c == [bg-"+containerId+"display-error] Render Chain Event == ", 'background: #888; color: #fff');
				    console.log("%c[error]", "font-weight: bold; color: red", error);
				});
				this.generatePageList();
			});
		}else{
			this.generatePageList();
		}
	}
	//暫停生成頁面清單
	passGeneratePageListProcess(_isStop = false){

		if(this._taskRendition[this._taskGenPageListKey] && this._taskRendition[this._taskGenPageListKey].taskData["isGetPageProcessGoing"]){

			if(this._taskRendition[this._taskGenPageListKey].taskData["waitRender"]){
				clearTimeout(this._taskRendition[this._taskGenPageListKey].taskData["waitRender"]);
			}

			if(_isStop){
				console.log("%c -- [genPageStop] generate Page List -- ", "color: yellow", this._taskRendition[this._taskGenPageListKey].taskData["pageList"]);
			}else{
				console.log("%c -- [genPagePass] generate Page List -- ", "color: yellow", this._taskRendition[this._taskGenPageListKey].taskData["pageList"]);
			}
			this._taskRendition[this._taskGenPageListKey].taskData["isGetPageProcessGoing"] = false;
			if(this._taskRendition[this._taskGenPageListKey].displaying){
				let displayed = this._taskRendition[this._taskGenPageListKey].displaying.promise;
				let passing = new defer();
				let passed = passing.promise;

				displayed.then(()=>{
					this._taskRendition[this._taskGenPageListKey].manager.q.clear();
					this._taskRendition[this._taskGenPageListKey].clear();
					this._taskRendition[this._taskGenPageListKey].taskData["pageList"] = [];
					this._taskRendition[this._taskGenPageListKey].taskData["curentSpineIndex"] = null;
					this._taskRendition[this._taskGenPageListKey].taskData["curentSpineNum"] = null;
					passing.resolve();
				});
				return passed;
			}else{
				this._taskRendition[this._taskGenPageListKey].manager.q.clear();
				this._taskRendition[this._taskGenPageListKey].clear();
				this._taskRendition[this._taskGenPageListKey].taskData["pageList"] = [];
				this._taskRendition[this._taskGenPageListKey].taskData["curentSpineIndex"] = null;
				this._taskRendition[this._taskGenPageListKey].taskData["curentSpineNum"] = null;
			}
		}else{
			return false;
		}
	}
	//停止
	stopGeneratePageListProcess(){
		if(this._taskRendition[this._taskGenPageListKey]){
			//移除任務型顯示器
			let passed = this.passGeneratePageListProcess(true);
			if(passed){
				let stopGoing = new defer();
				let stop = stopGoing.promise;
				passed.then(()=>{
					delete this._taskRendition[this._taskGenPageListKey];
					this._rendition.book.removeTaskRendition(this._taskGenPageListKey);
					stopGoing.resolve();
				});
				return stop;
			}else{
				delete this._taskRendition[this._taskGenPageListKey];
				this._rendition.book.removeTaskRendition(this._taskGenPageListKey);
				return false;
			}
		}
	}
	
	
	//(新版)tts清單-------------------------------------------------------------------------------------------
	//生成TTS清單
	/*generateTTSList() {
		if(this._taskRendition[this._taskGenTTSListKey] && (!this._taskRendition[this._taskGenTTSListKey].taskData || (this._taskRendition[this._taskGenTTSListKey].taskData && !this._taskRendition[this._taskGenTTSListKey].taskData["isGetRangeProcessGoing"]))){
			
			if(!this._taskRendition[this._taskGenTTSListKey].taskData){
				this._taskRendition[this._taskGenTTSListKey].taskData = {
					totalSpine: this._rendition.book.scrollBarNodeList.length - 1,
					preSpinePercentage: 100 / this._rendition.book.scrollBarNodeList.length,
					curentSpineIndex: null,
					curentSpineNum: null,
					task:this._taskGenTTSListKey,
					rangeList: [],
					startTimestamp: Math.floor(Date.now() / 1000)
				};
			}else{
				this._taskRendition[this._taskGenTTSListKey].taskData["rangeList"] = [];
				this._taskRendition[this._taskGenTTSListKey].taskData["curentSpineIndex"] = null;
				this._taskRendition[this._taskGenTTSListKey].taskData["curentSpineNum"] = null;
				this._taskRendition[this._taskGenTTSListKey].taskData["startTimestamp"] = Math.floor(Date.now() / 1000);
			}
			this._taskRendition[this._taskGenTTSListKey].taskData["isGetRangeProcessGoing"] = true;

			this._taskRendition[this._taskGenTTSListKey].manager.q.clear();
			this._taskRendition[this._taskGenTTSListKey].clear();

			//更新容器尺寸
			this._rendition.book.resizeTaskContainer(this._taskGenTTSListKey);
			if(this._rendition.settings.layout === "reflowable"){
				//更新layout
				let spread = (this._rendition._layout._spread) ? "auto" : "none";
				this._taskRendition[this._taskGenTTSListKey].spread(spread);

				//更新theme
				this._taskRendition[this._taskGenTTSListKey].themes.sync(this._rendition.themes);

				//更新目前閱讀設定
				this._taskRendition[this._taskGenTTSListKey].taskData["readSetting"] = {
					spread: spread,
					theme: this._rendition.themes._booksBackground,
					font: this._rendition.themes._booksFont,
					fontSize: this._rendition.themes._booksFontSize,
					lineHeight: this._rendition.themes._booksLineHeight,
					width:this._rendition._layout.props.width,
					height:this._rendition._layout.props.height
				};
			}

			this.emit(EVENTS.LOCATIONS.GEN_TTS_START, this._taskRendition[this._taskGenTTSListKey].taskData["rangeList"]);

			this._taskRendition[this._taskGenTTSListKey].spineDisplay(this._taskRendition[this._taskGenTTSListKey].book.scrollBarNodeList[0].spineItemsIndex, true);
		}
	}

	//加入TTS單一顯示範圍
	attachRangeListItem(locations, containerId){
		let sectionItemData = locations[0].start;
		let sectionIndex = sectionItemData.index;

		if(this._taskRendition[containerId] && this._taskRendition[containerId].taskData["isGetRangeProcessGoing"] && (this._taskRendition[containerId].taskData["curentSpineIndex"] === null || (this._taskRendition[containerId].taskData["curentSpineIndex"] !== null && this._taskRendition[containerId].taskData["curentSpineIndex"] !== sectionIndex))){

			this._taskRendition[containerId].taskData["curentSpineIndex"] = sectionIndex;
			this._taskRendition[containerId].taskData["curentSpineNum"] = (this._taskRendition[containerId].taskData["curentSpineNum"] === null) ? 0 : this._taskRendition[containerId].taskData["curentSpineNum"] + 1;
			
			let progressData;
			if(this._taskRendition[containerId].taskData["curentSpineNum"] !== this._taskRendition[containerId].taskData["totalSpine"]){

				this._taskRendition[containerId].taskData["rangeList"] = this._taskRendition[containerId].taskData["rangeList"].concat(locations);

				progressData = {
					percentage:Math.round((this._taskRendition[containerId].taskData["curentSpineNum"]+1) * this._taskRendition[containerId].taskData["preSpinePercentage"]),
					addItems: locations
				}

				this.emit(EVENTS.LOCATIONS.GEN_TTS_PROGRESS, progressData);

				if(this._taskRendition[containerId].taskData["waitRender"]){
					clearTimeout(this._taskRendition[containerId].taskData["waitRender"]);
				}
				this._taskRendition[containerId].taskData["waitRender"] = setTimeout(() => {

					let nextSpineNum = this._taskRendition[containerId].taskData["curentSpineNum"]+1;
					this._taskRendition[containerId].spineDisplay(this._taskRendition[containerId].book.scrollBarNodeList[nextSpineNum].spineItemsIndex, true);

				}, this._genTTSListWaitRenderTime);

			
			}else{

				//unload section
				let nowSection = this._taskRendition[containerId].book.spine.get(sectionIndex);
				if(nowSection && !nowSection._isNowDisplay){
					nowSection.unload();
				}

				this._taskRendition[containerId].taskData["rangeList"] = this._taskRendition[containerId].taskData["rangeList"].concat(locations);

				let startTimestamp = this._taskRendition[containerId].taskData["startTimestamp"];
				let endTimestamp = Math.floor(Date.now() / 1000);
				let completeTime = `${parseInt((endTimestamp-startTimestamp)/60)}:${(endTimestamp-startTimestamp)%60}`;
				
				progressData = {
					percentage:100,
					addItems: locations
				}
				this.emit(EVENTS.LOCATIONS.GEN_TTS_PROGRESS, progressData);

				this._taskRendition[containerId].taskData["isGetRangeProcessGoing"] = false;
				let remapData = {
					completeTime:completeTime,
					rangeList:this._taskRendition[containerId].taskData["rangeList"],
					readSetting:this._taskRendition[containerId].taskData["readSetting"]
				};
				this.emit(EVENTS.LOCATIONS.GEN_TTS_END, remapData);
				this.stopGenerateTTSListProcess();
			}
			
		}
	}

	//開始生成TTS清單
	startGenerateTTSListProcess(){
		if(!this._taskRendition[this._taskGenTTSListKey]){
			this._rendition.book.createTaskRendition(this._taskGenTTSListKey).then((containerId, taskRendition)=>{
				this._taskRendition[containerId] = taskRendition;
				this._taskRendition[containerId].on("getCaculateLocation", (locations) => this.attachRangeListItem.call(this, locations, containerId));
				this._taskRendition[containerId].on("displayerror", error => {
				    console.log("%c == [bg-"+containerId+"-display-error] Render Chain Event == ", 'background: #888; color: #fff');
				    console.log("%c[error]", "font-weight: bold; color: red", error);
				});
				this.generateTTSList();
			});
		}else{
			this.generateTTSList();
		}
	}

	//暫停生成TTS清單
	passGenerateTTSListProcess(_isStop = false){
		if(this._taskRendition[this._taskGenTTSListKey] && this._taskRendition[this._taskGenTTSListKey].taskData["isGetRangeProcessGoing"]){

			if(this._taskRendition[this._taskGenTTSListKey].taskData["waitRender"]){
				clearTimeout(this._taskRendition[this._taskGenTTSListKey].taskData["waitRender"]);
			}

			if(_isStop){
				console.log("%c -- [genTTSStop] generate TTS List -- ", "color: yellow", this._taskRendition[this._taskGenTTSListKey].taskData["rangeList"]);
			}else{
				console.log("%c -- [genTTSPass] generate TTS List -- ", "color: yellow", this._taskRendition[this._taskGenTTSListKey].taskData["rangeList"]);
			}
			this._taskRendition[this._taskGenTTSListKey].taskData["isGetRangeProcessGoing"] = false;
			if(this._taskRendition[this._taskGenTTSListKey].displaying){
				let displayed = this._taskRendition[this._taskGenTTSListKey].displaying.promise;
				let passing = new defer();
				let passed = passing.promise;

				displayed.then(()=>{
					this._taskRendition[this._taskGenTTSListKey].manager.q.clear();
					this._taskRendition[this._taskGenTTSListKey].clear();
					this._taskRendition[this._taskGenTTSListKey].taskData["rangeList"] = [];
					this._taskRendition[this._taskGenTTSListKey].taskData["curentSpineIndex"] = null;
					this._taskRendition[this._taskGenTTSListKey].taskData["curentSpineNum"] = null;
					passing.resolve();
				});
				return passed;
			}else{
				this._taskRendition[this._taskGenTTSListKey].manager.q.clear();
				this._taskRendition[this._taskGenTTSListKey].clear();
				this._taskRendition[this._taskGenTTSListKey].taskData["rangeList"] = [];
				this._taskRendition[this._taskGenTTSListKey].taskData["curentSpineIndex"] = null;
				this._taskRendition[this._taskGenTTSListKey].taskData["curentSpineNum"] = null;
			}
		}else{
			return false;
		}
	}
	//停止生成TTS清單
	stopGenerateTTSListProcess(){
		if(this._taskRendition[this._taskGenTTSListKey]){
			//移除任務型顯示器
			let passed = this.passGenerateTTSListProcess(true);
			if(passed){
				let stopGoing = new defer();
				let stop = stopGoing.promise;
				passed.then(()=>{
					delete this._taskRendition[this._taskGenTTSListKey];
					this._rendition.book.removeTaskRendition(this._taskGenTTSListKey);
					stopGoing.resolve();
				});
				return stop;
			}else{
				delete this._taskRendition[this._taskGenTTSListKey];
				this._rendition.book.removeTaskRendition(this._taskGenTTSListKey);
				return false;
			}
		}
	}
	*/
	
	parse(contents, cfiBase, chars, isOnlyStart = false) {
		var locations = [];
		var range;
		var doc = contents.ownerDocument;
		var body = qs(doc, "body");
		var counter = 0;
		var prev;
		var _break = chars || this.break;
		var parser = function(node) {
			var len = node.length;
			var dist;
			var pos = 0;

			if (node.textContent.trim().length === 0) {
				return false; // continue
			}

			// Start range
			if (counter == 0) {
				range = this.createRange();
				range.startContainer = node;
				range.startOffset = 0;
			}

			dist = _break - counter;

			// Node is smaller than a break,
			// skip over it
			if(dist > len){
				counter += len;
				pos = len;
			}


			while (pos < len) {
				dist = _break - counter;

				if (counter === 0) {
					// Start new range
					pos += 1;
					range = this.createRange();
					range.startContainer = node;
					range.startOffset = pos;
				}

				// pos += dist;

				// Gone over
				if(pos + dist >= len){
					// Continue counter for next node
					counter += len - pos;
					// break
					pos = len;
				// At End
				} else {
					// Advance pos
					pos += dist;

					// End the previous range
					range.endContainer = node;
					range.endOffset = pos;
					// cfi = section.cfiFromRange(range);
					let cfi = new ExEpubCFI(range, cfiBase).toString();
					if(isOnlyStart){
						let epubcfi = new ExEpubCFI();
						let startCFI = epubcfi.getStartCFIFromRange(cfi);
						let endCFI = epubcfi.getEndCFIFromRange(cfi);
						if(locations.indexOf(startCFI) < 0){
							locations.push(startCFI);
						}
						if(locations.indexOf(endCFI) < 0){
							locations.push(endCFI);
						}
					}else{
						locations.push(cfi);
					}
					counter = 0;
				}
			}
			prev = node;
		};

		sprint(body, parser.bind(this));

		// Close remaining
		if (range && range.startContainer && prev) {
			range.endContainer = prev;
			range.endOffset = prev.length;
			let cfi = new ExEpubCFI(range, cfiBase).toString();
			if(isOnlyStart){
				let epubcfi = new ExEpubCFI();
				let startCFI = epubcfi.getStartCFIFromRange(cfi);
				let endCFI = epubcfi.getEndCFIFromRange(cfi);
				if(locations.indexOf(startCFI) < 0){
					locations.push(startCFI);
				}
				if(locations.indexOf(endCFI) < 0){
					locations.push(endCFI);
				}
			}else{
				locations.push(cfi);
			}
			counter = 0;
		}

		return locations;
	}

	//從cpct產生cfi
	generateCFIFromCpct(taskKey, cpct){
		//console.log("generateCFIFromCpct");

		if(!cpct){
			return;
		}

		let cfi = undefined;
		let epubcfi = new ExEpubCFI();
		let section, percentage, uuids;
		
		if(typeof cpct === "object"){
			$.each(cpct, (uuid, cpct) => {
				if(!section){
					section = this.spine.get(cpct);
				}
				if(!uuids){
					uuids = [uuid];
				}else{
					uuids.push(uuid);
				}
				if(!percentage){
					percentage = [epubcfi.getSpinePercentageFromCpct(cpct)];
				}else{
					percentage.push(epubcfi.getSpinePercentageFromCpct(cpct));
				}
		   });
		}else{
			uuids = null;
			section = this.spine.get(cpct);
			percentage = epubcfi.getSpinePercentageFromCpct(cpct);
		}
		if(section && section.contents){
			if(!this._taskRendition[taskKey]){
				return this._rendition.book.createTaskRendition(taskKey).then((containerId, taskRendition)=>{

					let completed = new defer();

					this._taskRendition[containerId] = taskRendition;
					this._taskRendition[containerId].on("getCaculateLocation", (cfiArray) => this.conventCFIFromCpct.call(this, cfiArray, containerId));

					//加入 taskData
					this._taskRendition[containerId].taskData = {
						task: taskKey,
						cpct: cpct,
						section: section,
						uuids: uuids,
						percentage: percentage,
						completed: completed
					};

					//更新容器尺寸
					this._rendition.book.resizeTaskContainer(containerId);
		
					if(this._rendition.settings.layout === "reflowable"){
						//更新layout(always none)
						let spread = (this._rendition._layout._spread) ? "auto" : "none";
						this._taskRendition[containerId].spread(spread);

						//更新theme
						this._taskRendition[containerId].themes.sync(this._rendition.themes);
					}

					//開始顯示
					this._taskRendition[containerId].spineDisplay(section.index, percentage);
					return completed.promise;
				});
			}else{
				return this._taskRendition[taskKey];
			}
	    }else{
		   return cfi;
	    }
	}
	conventCFIFromCpct(cfiArray, containerId){
		let cfiResult = null;
		if(typeof this._taskRendition[containerId].taskData.cpct === "object"){
			cfiResult = {};
			this._taskRendition[containerId].taskData.uuids.forEach((uuid, index) => {
				cfiResult[uuid] = cfiArray[index];
			});
		}else{
			cfiResult = cfiArray[0];
		}

		this._taskRendition[containerId].taskData.completed.resolve(cfiResult);

		//發出事件
		this.emit(EVENTS.LOCATIONS.GET_CPCT_CFI, cfiResult);

		//移除任務型顯示器
		delete this._taskRendition[containerId];
		this._rendition.book.removeTaskRendition(containerId);
	}

	/**
	 * Load all of sections in the book to generate locations
	 * @param  {string} startCfi start position
	 * @param  {int} wordCount how many words to split on
	 * @param  {int} count result count
	 * @return {object} locations
	 */
	generateFromWords(startCfi, wordCount, count) {
		var start = startCfi ? new ExEpubCFI(startCfi) : undefined;
		this.q.pause();
		this._locationsWords = [];
		this._wordCounter = 0;

		this.spine.each(function(section) {
			if (section.linear) {
				if (start) {
					if (section.index >= start.spinePos) {
						this.q.enqueue(this.processWords.bind(this), section, wordCount, start, count);
					}
				} else {
					this.q.enqueue(this.processWords.bind(this), section, wordCount, start, count);
				}
			}
		}.bind(this));

		return this.q.run().then(function() {
			if (this._currentCfi) {
				this.currentLocation = this._currentCfi;
			}

			return this._locationsWords;
		}.bind(this));

	}

    parseWords(contents, section, wordCount, startCfi) {
		var cfiBase = section.cfiBase;
		var locations = [];
		var doc = contents.ownerDocument;
		var body = qs(doc, "body");
		var prev;
		var _break = wordCount;
		var foundStartNode = startCfi ? startCfi.spinePos !== section.index : true;
		var startNode;
		if (startCfi && section.index === startCfi.spinePos) {
			startNode = startCfi.findNode(startCfi.range ? startCfi.path.steps.concat(startCfi.start.steps) : startCfi.path.steps, contents.ownerDocument);
		}
		var parser = function(node) {
			if (!foundStartNode) {
				if (node === startNode) {
					foundStartNode = true;
				} else {
					return false;
				}
			}
			if (node.textContent.length < 10) {
				if (node.textContent.trim().length === 0) {
					return false;
				}
			}
			var len  = this.countWords(node.textContent);
			var dist;
			var pos = 0;

			if (len === 0) {
				return false; // continue
			}

			dist = _break - this._wordCounter;

			// Node is smaller than a break,
			// skip over it
			if (dist > len) {
				this._wordCounter += len;
				pos = len;
			}


			while (pos < len) {
				dist = _break - this._wordCounter;

				// Gone over
				if (pos + dist >= len) {
					// Continue counter for next node
					this._wordCounter += len - pos;
					// break
					pos = len;
					// At End
				} else {
					// Advance pos
					pos += dist;

					let cfi = new ExEpubCFI(node, cfiBase);
					locations.push({ cfi: cfi.toString(), wordCount: this._wordCounter });
					this._wordCounter = 0;
				}
			}
			prev = node;
		};

		sprint(body, parser.bind(this));

		return locations;
	}

    /**
	 * Get a location from an EpubCFI
	 * @param {EpubCFI} cfi
	 * @return {number}
	 */
	locationFromCfi(cfi){
		let loc;
		if (ExEpubCFI.prototype.isCfiString(cfi)) {
			cfi = new ExEpubCFI(cfi);
		}
		// Check if the location has not been set yet
		if(this._locations.length === 0) {
			return -1;
		}

		loc = locationOf(cfi, this._locations, this.epubcfi.compare);

		if (loc > this.total) {
			return this.total;
		}

		return loc;
	}

    /**
	 * Get an EpubCFI from location percentage
	 * @param {number} percentage
	 * @return {EpubCFI} cfi
	 */
	cfiFromPercentage(percentage){
		let loc;
		if (percentage > 1) {
			console.warn("Normalize cfiFromPercentage value to between 0 - 1");
		}

		// Make sure 1 goes to very end
		if (percentage >= 1) {
			let cfi = new ExEpubCFI(this._locations[this.total]);
			cfi.collapse();
			return cfi.toString();
		}

		loc = Math.ceil(this.total * percentage);
		return this.cfiFromLocation(loc);
	}
}

export default ExLocation;